const overviewTours = {
  visaoGeral: {
    tourId: "visaoGeral",
    steps: [
      {
        target: "[data-tour='autoconfig-visao-geral-checklist']",
        title: "Bem-vindo a auto configuracao",
        content: "Esta lista mostra tudo o que ainda precisa ser configurado para deixar sua entidade pronta para uso. Voce pode seguir a ordem sugerida ou pular para qualquer etapa quando quiser.",
      },
      {
        target: "[data-tour='autoconfig-visao-geral-proxima']",
        title: "Avancar entre as etapas",
        content: "Use este botao para avancar. Em cada etapa, configure o que for pedido antes de seguir para a proxima.",
      },
    ],
  },
  preferenciasEntidade: {
    tourId: "preferenciasEntidade",
    steps: [
      {
        target: "[data-tour='autoconfig-preferencias-abrir']",
        title: "Preferencias da entidade",
        content: "Clique aqui para abrir as preferencias e configurar logotipo, armazenamento, interface, privacidade e comunicacao da sua entidade.",
      },
      {
        target: "[data-tour='pref-tab-geral']",
        title: "Geral",
        content: "Cadastre o logotipo da empresa aqui. Ele passa a aparecer no cabecalho do sistema e nos documentos gerados para esta entidade.",
      },
      {
        target: "[data-tour='pref-tab-armazenamento']",
        title: "Armazenamento",
        content: "Defina o tamanho maximo permitido por arquivo, o numero maximo de anexos por documento e se os aditivos tambem podem receber anexos.",
      },
      {
        target: "[data-tour='pref-tab-interface']",
        title: "Interface",
        content: "Escolha a quantidade padrao de linhas exibidas por pagina nas listagens (grids) do sistema.",
      },
      {
        target: "[data-tour='pref-tab-privacidade']",
        title: "Privacidade",
        content: "Ative a mascara de dados sensiveis (LGPD) para ocultar informacoes pessoais de usuarios sem permissao para visualiza-las.",
      },
      {
        target: "[data-tour='pref-tab-comunicacao']",
        title: "Comunicacao",
        content: "Defina se as notificacoes de documentos pendentes devem ser agrupadas em um unico e-mail diario por usuario, ou enviadas individualmente no horario de cada agendamento.",
      },
    ],
  },
  gruposUsuario: {
    tourId: "gruposUsuario",
    steps: [
      {
        target: "[data-tour='grupos-usuario-adicionar']",
        title: "Criar um novo grupo",
        content: "Cadastre quantos grupos precisar para segregar o acesso por filial ou por tipo de documento - por exemplo, um grupo so para o financeiro ou so para uma unidade especifica.",
      },
      {
        target: "[data-tour='grupos-usuario-primeira-linha']",
        title: "Editar um grupo existente",
        content: "Clique em um grupo para abrir e ajustar suas permissoes: quais menus ele acessa, e a quais filiais e tipos de documento ele fica restrito.",
      },
    ],
  },
  usuarios: {
    tourId: "usuarios",
    steps: [
      {
        target: "[data-tour='usuarios-adicionar']",
        title: "Usuario Comunicado",
        content: "Aqui voce cadastra os usuarios que acessam o sistema, mas tambem pode criar usuarios do tipo Comunicado. Esse tipo nao faz login: ele existe so para receber notificacoes por e-mail (alertas de documentos, avisos etc.), sem ocupar uma licenca operacional. E a forma mais simples de incluir alguem no fluxo de comunicacao - como um financeiro ou um gestor que so precisa ser avisado - sem contar no limite de usuarios do seu plano.",
      },
    ],
  },
  tiposAgendamento: {
    tourId: "tiposAgendamento",
    steps: [
      {
        target: "[data-tour='tipos-agendamento-usuarios-notificacao']",
        title: "Tipos de Agendamento",
        content: "O assistente ja cria exemplos de tipos de agendamento ao abrir esta etapa. Eles servem como ponto de partida para definir quando os alertas de vencimento serao gerados, e podem ser modificados pelo usuario depois.",
      },
      {
        target: "[data-tour='tipos-agendamento-usuarios-notificacao']",
        title: "Usuarios para Notificacao",
        content: "Nesta acao voce escolhe quem recebe o aviso quando um documento deste tipo de agendamento estiver proximo do vencimento ou vencido. Vale tanto para usuarios normais quanto para usuarios do tipo Comunicado.",
      },
    ],
  },
  tiposPagamento: {
    tourId: "tiposPagamento",
    steps: [
      {
        target: "[data-tour='tipos-pagamento-cadastro']",
        title: "Tipos de Pagamento",
        content: "O assistente ja cria exemplos de tipos de pagamento ao abrir esta etapa, como Mensal, Quinzenal, Semestral e Anual. Eles servem como ponto de partida e podem ser modificados pelo usuario depois.",
      },
    ],
  },
  tiposFornecedor: {
    tourId: "tiposFornecedor",
    steps: [
      {
        target: "[data-tour='tipos-fornecedor-adicionar']",
        title: "Cadastrar um tipo de fornecedor",
        content: "Cadastre aqui as categorias que classificam seus fornecedores (ex.: Prefeitura Municipal, Corpo de Bombeiros, Vigilancia Sanitaria) - util para organizar e filtrar depois.",
      },
      {
        target: "[data-tour='autoconfig-incluir-sugestoes']",
        title: "Incluir Sugestoes",
        content: "Clique aqui para incluir automaticamente os tipos de fornecedor mais comuns, prontos para uso - facilita bastante e evita ter que cadastrar tudo do zero.",
      },
    ],
  },
  fornecedores: {
    tourId: "fornecedores",
    steps: [
      {
        target: "[data-tour='fornecedores-adicionar']",
        title: "Cadastrar um fornecedor",
        content: "Cadastre aqui as empresas que prestam servico para voce. Assim voce pode vincular documentos diretamente ao fornecedor - ou, no caso de prestacao de servico interna, aos colaboradores dele - mantendo tudo organizado e rastreavel.",
      },
    ],
  },
  filiais: {
    tourId: "filiais",
    steps: [
      {
        target: "[data-tour='filiais-adicionar']",
        title: "Filial padrao",
        content: "O assistente ja cria automaticamente uma filial padrao com os dados da entidade, incluindo o mesmo CNPJ. Ela serve como ponto de partida e pode ser alterada pelo usuario depois.",
      },
      {
        target: "[data-tour='filiais-adicionar']",
        title: "Cadastrar outras filiais",
        content: "Cadastre aqui outras unidades da sua empresa. Cada filial pode ter seus proprios documentos e funcionarios, organizados separadamente da matriz.",
      },
      {
        target: "[data-tour='filiais-config-campos']",
        title: "Configurar campos da filial",
        content: "Use a engrenagem para alterar a visibilidade e a obrigatoriedade dos campos desta filial, alem da ordem em que eles aparecem para preenchimento.",
      },
    ],
  },
  funcionarios: {
    tourId: "funcionarios",
    steps: [
      {
        target: "[data-tour='funcionarios-adicionar']",
        title: "Cadastro manual",
        content: "Use este botao para incluir um funcionario de cada vez, informando os dados diretamente no formulario.",
      },
      {
        target: "[data-tour='funcionarios-importar-via-xlsx']",
        title: "Importar Via XLSX",
        content: "Baixe uma planilha modelo ja preenchida com as filiais e fornecedores cadastrados. Com Fornecedores e Filiais ja configurados, voce consegue importar de uma vez os funcionarios de cada unidade ou empresa prestadora de servico, associando cada um ao lugar certo.",
      },
      {
        target: "[data-tour='funcionarios-importar-xlsx']",
        title: "Importar XLSX",
        content: "Depois de preencher a planilha baixada, envie o arquivo aqui para cadastrar varios funcionarios de uma so vez.",
      },
    ],
  },
  indicesCorrecao: {
    tourId: "indicesCorrecao",
    steps: [
      {
        target: "[data-tour='indices-correcao-adicionar']",
        title: "Indices de Correcao",
        content: "O assistente ja cria exemplos comuns ao abrir esta etapa: INPC, IPCA, INCC e IGPM. Eles sao um ponto de partida e podem ser modificados pelo usuario depois.",
      },
      {
        target: "[data-tour='indices-correcao-adicionar']",
        title: "Cadastrar outro indice",
        content: "Se precisar de um indice que nao esta na lista inicial, cadastre aqui manualmente.",
      },
    ],
  },
  camposCustomizados: {
    tourId: "camposCustomizados",
    steps: [
      {
        target: "[data-tour='campos-customizados-adicionar']",
        title: "Cadastrar um campo customizado",
        content: "Clique aqui para criar um campo extra, alem dos padroes do sistema, para guardar uma informacao especifica de um documento (ex.: placa do veiculo, valor pago).",
      },
      {
        target: "[data-tour='campos-customizados-nome']",
        title: "Nome do campo",
        content: "O nome que vai aparecer no formulario do documento, ex.: 'Placa do veiculo' ou 'Valor pago'.",
      },
      {
        target: "[data-tour='campos-customizados-tipo-documento']",
        title: "Tipo de documento",
        content: "Deixe sem selecao para usar em todos os tipos de documento, ou selecione um ou mais tipos para restringir onde o campo aparece.",
      },
      {
        target: "[data-tour='campos-customizados-tipo-campo']",
        title: "Tipo do campo",
        content: "Define o formato do valor: numero inteiro, decimal, data, ou uma lista fixa de opcoes (Cadastro) que o usuario escolhe ao preencher o documento.",
      },
      {
        target: "[data-tour='campos-customizados-ativo']",
        title: "Ativo",
        content: "Desative para deixar de exibir e usar este campo, sem precisar excluir o cadastro.",
      },
      {
        target: "[data-tour='campos-customizados-visivel']",
        title: "Visivel",
        content: "Controla se o campo aparece no formulario do documento para os usuarios preencherem.",
      },
      {
        target: "[data-tour='campos-customizados-obrigatorio']",
        title: "Obrigatorio",
        content: "Exige o preenchimento do campo antes de salvar o documento.",
      },
      {
        target: "[data-tour='campos-customizados-dados-pessoais']",
        title: "Dados pessoais",
        content: "Marque se o valor deste campo identifica uma pessoa (ex.: nome, CPF, e-mail). Campos marcados sao mascarados nas exportacoes quando a protecao de dados (LGPD) da entidade esta ativa.",
      },
    ],
  },
  tiposDocumento: {
    tourId: "tiposDocumento",
    steps: [
      {
        target: "[data-tour='tipos-documento-adicionar']",
        title: "Tipos de Documento iniciais",
        content: "O assistente ja cria exemplos ao abrir esta etapa: Alvara de Funcionamento, Apolice de Seguro, NR 12 e CNH. Eles servem como ponto de partida e podem ser modificados pelo usuario depois.",
      },
      {
        target: "[data-tour='tipos-documento-adicionar']",
        title: "Cadastrar outro tipo",
        content: "Se precisar de um tipo de documento que nao esta na lista inicial, cadastre aqui manualmente.",
      },
      {
        target: "[data-tour='tipos-documento-config-campos']",
        title: "Configurar campos do tipo de documento",
        content: "Use a engrenagem para alterar a visibilidade e a obrigatoriedade dos campos deste tipo de documento, alem da ordem em que eles aparecem para preenchimento.",
      },
      {
        target: "[data-tour='tipos-documento-vincular-agendamento']",
        title: "Vincular Tipos de Agendamento",
        content: "Defina aqui os tipos de agendamento deste tipo de documento - eles determinam como e quando um alerta de vencimento sera enviado.",
      },
    ],
  },
  emailNotificacao: {
    tourId: "emailNotificacao",
    steps: [
      {
        target: "[data-tour='email-adicionar']",
        title: "Cadastrar uma configuracao de email",
        content: "Clique aqui para definir o remetente usado nos alertas automaticos (vencimento de documentos, avisos, etc.).",
      },
      {
        target: "[data-tour='email-provedor-rapido']",
        title: "Configuracao rapida",
        content: "Se usa Gmail ou Outlook/Microsoft 365, clique no provedor aqui para preencher automaticamente servidor, porta, seguranca da conexao e metodo de autenticacao.",
      },
      {
        target: "[data-tour='email-servidor-autenticacao']",
        title: "Servidor e Autenticacao",
        content: "Se preferir nao usar a configuracao rapida (ex.: outro provedor ou servidor proprio), preencha estes dois blocos manualmente - eles formam uma coisa so: os dados tecnicos do servidor (Servidor e conexao) e as credenciais de quem envia (Autenticacao).",
      },
    ],
  },
  classificacaoTiposDocumento: {
    tourId: "classificacaoTiposDocumento",
    steps: [
      {
        target: "[data-tour='classificacao-tipos-documento-adicionar']",
        title: "Classificacoes iniciais",
        content: "O assistente ja cria exemplos de classificacao ao abrir esta etapa: Empresa e Outros. Eles servem como ponto de partida e podem ser modificados pelo usuario depois.",
      },
      {
        target: "[data-tour='classificacao-tipos-documento-adicionar']",
        title: "Cadastrar outra classificacao",
        content: "Se precisar de uma classificacao que nao esta na lista inicial, cadastre aqui manualmente.",
      },
    ],
  },
  empresas: {
    tourId: "empresas",
    steps: [
      {
        target: "[data-tour='page-title']",
        title: "Cadastro",
        content: "Aqui voce identifica a rotina aberta e a entidade em uso.",
      },
      {
        target: "[data-tour='grid-actions']",
        title: "Acoes da tela",
        content: "Use esta area para incluir, exportar, filtrar ou ajustar a visualizacao.",
      },
      {
        target: "[data-tour='grid-content']",
        title: "Registros",
        content: "A lista mostra os registros cadastrados e permite acessar edicao, configuracoes e acoes.",
      },
    ],
  },
};

export default overviewTours;
